import Vue from 'vue'
import App from './components/App.vue'
import router from './routes'
import store from './vuex/store';
import i18n from './functions/I18n'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faChevronLeft, faChevronRight, faAngleRight,faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
require('dotenv').config();

library.add(faUserSecret);
library.add(faChevronLeft, faChevronRight);
new Vue({
    el: '#app',
    render: h => h(App),
    store,
    i18n,
    router,
    mounted() {
    this.$router.replace('/') // added this
    }
})
// router.replace('/')
Vue.component('font-awesome-icon', FontAwesomeIcon)